// extracted by mini-css-extract-plugin
export var copyIcon = "_rk-2";
export var discountCard = "_rk-0";
export var discountCode = "_rk-3";
export var discountContent = "_rk-1";
export var loadingCard = "_rk-4";